var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pteMode == 'ptea' && _vm.type.is_ptea && !_vm.type.is_ptec)?_c('span',{staticClass:"color-primary"},[_vm._v(" (PTEA)")]):(_vm.pteMode == 'ptec' && _vm.type.is_ptec && !_vm.type.is_ptea)?_c('span',{staticClass:"color-primary"},[_vm._v(" (Core)")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }